import PersistentLoginUtil from '@component/common/src/util/PersistentLoginUtil';
import getDeviceType from './DeviceTypeUtil';
import * as xApiActionHeaderValues from '../static/actionMaps/xapi_deeplinks.json';
import * as shopAppActionMap from '../static/actionMaps/shopapp_deeplinks.json';
import * as shopAppActionMapEmails from '../static/actionMaps/shopapp_email_deeplinks.json';

// This module contains two functions for setting up the AJAX request to
// make in order to get the URL to which to redirect the user on Citi Fusion.
// One function is for setting up an xAPI request, another for ShopApp

// Returns an object containing the settings for the AJAX request to be made
// this is for an xAPI request
export const xAPISetUpRequest = (options) => {
  const { action } = options;
  const defaultAction = 'dashboard';
  let params = options.params || {};
  let method;
  let ajaxURL;
  let requestHeaders;
  let actionMap;

  const ssoEndpoint = '/account-xapi/api/creditservice/creditdeeplink';
  const emailDeeplinkEndpoint = '/account-xapi/api/creditservice/emaildeeplink';
  let xApiHeaders = {
    'x-macys-clientid': 'account-ui',
    'Content-Type': 'application/json',
  };

  PersistentLoginUtil.setDeviceFingerPrint();
  xApiHeaders = { ...xApiHeaders, ...PersistentLoginUtil.setHeader() };
  const deviceType = getDeviceType();

  // Params, data sent in request body
  if (typeof params === 'string') {
    params = JSON.parse(params);
  }

  if (options.isEmailDeepLink) {
    if (params.CID) {
      delete params.CID;
    }
    const { cmmmc, linkProc, uid } = options;

    // Email deeplink sends a body with everything under creditEmailDeeplinkData obj
    params.creditEmailDeeplinkData = {
      processIndicator: action,
      linkProc,
      cmmmc,
      uid,
    };

    // Different endpoint for emaildeeplink versus credit servicing link
    // emaildeeplink also uses a POST request
    // RenderPageComponent will have params already configured
    ajaxURL = `${emailDeeplinkEndpoint}?_deviceType=${deviceType}`;
    method = 'POST';

    // For email deeplinks, if there is no action, or the action is invalid (not in mapping), use dashboard
    if (!action || !shopAppActionMapEmails[action]) {
      params.creditEmailDeeplinkData.processIndicator = defaultAction;
    }
  } else {
    if (params.CID) {
      xApiHeaders.CID = params.CID;
      delete params.CID;
    }
    // User might pass in actionMap as an option
    actionMap = options.actionMap || xApiActionHeaderValues;

    // Need to include the action as a request header
    // Map options.action to action accepted by xAPI request
    const actionValue = actionMap[action];
    if (typeof actionValue === 'object') {
      ajaxURL = actionValue.url;
      method = actionValue.method;
    } else {
      ajaxURL = ssoEndpoint;
      method = 'GET';
      if (actionValue) {
        xApiHeaders.action = actionValue;
      } // If the action is invalid, and error message will be displayed in SpeedBumpOverlay
    }

    params._deviceType = deviceType;
  }

  // Headers
  // If options already has headers, then use those,
  // along with standard xAPI headers (action, x-Macys-ClientId, etc.)
  if (options.headers) {
    const headers = typeof options.headers === 'string' ? JSON.parse(options.headers) : options.headers;
    requestHeaders = Object.assign({}, headers, xApiHeaders);
  } else {
    requestHeaders = xApiHeaders;
  }

  const ajaxRequestSettings = {
    method,
    url: ajaxURL,
    data: params,
    headers: requestHeaders,
    contentType: 'application/json; charset=utf-8',
  };

  return ajaxRequestSettings;
};

// Uses older way to set up request
export const shopAppSetUpRequest = (options) => {
  let { action } = options;
  const { linkProc } = options;
  let params = options.params || {};
  let method;
  let ajaxURL;
  let requestHeaders;
  let actionMap;
  const defaultAction = 'dashboard';

  if (options.isEmailDeepLink) {
    actionMap = shopAppActionMapEmails;

    if (!action || !actionMap[action]) {
      action = defaultAction;
    }

    params.linkProc = linkProc;
  } else {
    actionMap = options.actionMap || shopAppActionMap;
  }

  // Params, data sent in request body
  if (typeof params === 'string') {
    params = JSON.parse(params);
  }

  if (params.creditEmailDeeplinkData) {
    delete params.creditEmailDeeplinkData;
  }

  // Ajax and populates with the values from the result
  const postBuilderAction = actionMap[action];

  // URL
  if (typeof postBuilderAction === 'object') {
    ajaxURL = postBuilderAction.url;
  } else {
    ajaxURL = postBuilderAction;
  }

  // Method
  method = (!params || !Object.keys(params).length) ? 'get' : 'post';
  // Override method if we specify a method in action map
  if (typeof postBuilderAction === 'object') {
    method = postBuilderAction.method; // eslint-disable-line prefer-destructuring
  }

  if (options.headers) {
    requestHeaders = options.headers;
  }

  const ajaxRequestSettings = {
    method,
    url: ajaxURL,
    data: params,
  };

  if (requestHeaders) {
    ajaxRequestSettings.headers = requestHeaders;
  }

  return ajaxRequestSettings;
};

